import { InitialLoading } from '@/components/loading/initial';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { healthCheck } from '@/query';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { IBinaryConfig } from '..';
import { FEED_BINARY_CONFIG, FEED_BINARY_CONFIG_DEFAULT } from '../../../constants';
import { ReleaseChannelErrorModal, isReleaseChannelErrorResponse } from '../release-channel-modal';

interface IConfigPros {
  onSuccess: () => void;
}

export function CheckBinaryConfig({ onSuccess }: IConfigPros) {
  const [value, setValue] = useLocalStorage<IBinaryConfig>(FEED_BINARY_CONFIG, FEED_BINARY_CONFIG_DEFAULT);
  const [releaseChannelError, setReleaseChannelError] = useState<string | null>(null);

  async function handleSubmit() {
    if (value?.error) {
      return;
    }

    const ping = await fetch('fdm://internal/config', {
      method: 'POST',
      body: JSON.stringify(value)
    });

    const pingResponse = await ping.json();

    if (ping.status !== 200 && ping.status !== 208) {
      console.log({ pingResponse });

      if (isReleaseChannelErrorResponse(pingResponse)) {
        setReleaseChannelError(pingResponse.message || 'Canal de versão incompatível com o banco de dados.');
        return;
      }

      toast.error(`Erro ao iniciar o feed manager: ${pingResponse.message}`);
      setValue((v) => ({ ...v!, error: true }));
      return;
    }

    const { data, status } = await healthCheck();

    if (status !== 200) {
      console.log({ healthcheck: data });
      toast.error(
        `Feed manager está instável:\ndb: ${data.database}\nenv: ${data.environment}\nstatus: ${data.status}\nuptime: ${data.uptime}\n version: ${data.version}`
      );
      setValue((v) => ({ ...v!, error: true }));
      return;
    }

    onSuccess();
  }

  useEffect(() => {
    handleSubmit().catch(console.error);
  }, []);

  return (
    <>
      <InitialLoading text="Carregando o feed manager..." />

      <ReleaseChannelErrorModal
        open={Boolean(releaseChannelError)}
        message={releaseChannelError || ''}
        onClose={() => {
          setReleaseChannelError(null);
          setValue((v) => ({ ...v!, error: true }));
        }}
      />
    </>
  );
}
